// @flow

import { Component } from '../../jsti/core';
import Notifications from '../../constants/Notifications';

export default class AbstractPagination extends Component {
  /**
   * Initialization
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.addListener(Notifications.PAGINATE, this.handlePaginate);
  }

  /**
   * Executes when the user paginates
   */
  handlePaginate(pData: Object): void {
    throw new Error('Abstract method');
  }

  /**
   * Send an API request
   */
  sendRequest(): void {
    throw new Error('Abstract method');
  }

  /**
   * Rebuild the component
   */
  rebuildComponent(pHtml: string): void {
    this.el.innerHTML = pHtml;
  }
}
